import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowInbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowInbox"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 14V19.5H19.5V14H21V21H3V14H4.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 16.0607L16.5607 11.5L15.5 10.4393L12.75 13.1893V3H11.25V13.1893L8.5 10.4393L7.43934 11.5L12 16.0607Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowInbox;
